import { css } from '@emotion/react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import React from 'react'
import colorNames from '../../design/color-names'
import tokens from '../../design/tokens'
import { ICON_FA_VARIANT_SOLID, IconFACheck } from '../SVGIcons'

const StyledCard = styled.div`
  position: relative;
  background-color: ${colorNames.pureWhite};
  outline: 1px solid ${colorNames.geyser};
  border-radius: ${tokens.borderRadius.medium};
  padding: 20px 30px 30px;
  text-align: ${props => props.textAlign};
  border: 2px solid transparent;
  height: 100%;  
  transition: all 0.25s ease;
  ${props =>
    props.onClick &&
    !props.disabled &&
    css`
      &:hover {
        box-shadow: ${tokens.shadows.default};
        cursor: pointer;
      }
    `}
  ${props =>
    props.disabled &&
    css`
      opacity: 0.5;
      cursor: default;
    `}
  ${props =>
    props.selected &&
    css`
      border: 2px solid ${colorNames.java};
      outline: 1px solid transparent;
    `}
`

const StyledCardAbsoluteCorner = styled.div`
  display: flex;
  position: absolute;
  top: 20px;
  right: 30px;
`
const StyledIconCheckContainer = styled.div`
  position: relative;
  background-color: #e0f3f9;
  width: 22px;
  height: 22px;
  border-radius: ${tokens.borderRadius.max};
  margin-left: 8px;
`
const StyledIconCheck = styled(IconFACheck)`
  position: absolute;
  left: 4px;
  top: 3px;
  color: ${colorNames.java};
  font-size: 13px;
`

export const Card = ({ className, ...props }) => {
  return (
    <StyledCard {...props} className={className}>
      {props.children}
      <StyledCardAbsoluteCorner>
        {props.childrenAbsoluteCorner}
        {props.selected && (
          <StyledIconCheckContainer>
            <StyledIconCheck variant={ICON_FA_VARIANT_SOLID} />
          </StyledIconCheckContainer>
        )}
      </StyledCardAbsoluteCorner>
    </StyledCard>
  )
}

Card.defaultProps = {
  textAlign: 'center'
}

Card.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
  childrenAbsoluteCorner: PropTypes.node,
  selected: PropTypes.bool,
  textAlign: PropTypes.oneOf(['left', 'right', 'center', 'justify'])
}
